var _dec, _class;

import { Model, model, prop } from "mobx-keystone";
import { GesturePointModel } from "./GesturePointModel";
export let CircleGestureModel = (_dec = model("combat/CircleGestureModel"), _dec(_class = class CircleGestureModel extends Model({
  center: prop(() => new GesturePointModel({})).withSetter(),
  radius: prop(1).withSetter()
}) {}) || _class);